/** Join class names, dropping falsy entries. Small on purpose - no clsx/cva dependency. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
